module.exports = __webpack_public_path__ + "img/delete.981936c5.png";